
/* injects from baggage-loader */

'use strict';

import ProjectEditorComponent from './project-editor.component';

const ProjectEditorPageModule = angular.module('project-editor-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('project-editor', {
        url: '/project/{id}/edit',
        // Requires valid login to view
        protected: true,
        component: 'projectEditor',
        // Resolve promises into controller bindings, see component for bindings
        resolve: {
          project: function (Projects, $transition$) {
            return Projects.get($transition$.params('to').id);
          },
          documents: function (project) {
            let query = project.relation('documents').query();
            query.ascending("createdAt");
            return query.find();
          },
          comments: function (project) {
            let query = project.relation('comments').query();
            query.descending("createdAt");
            query.include(['author', 'author.image']);
            query.select(['author.first_name', 'author.last_name', 'text', 'author_tag', 'parent', 'project'])
            return query.find();
          },
          rewards: function (project, ProjectRewardSchema) {
            let query = project.relation('pledge_rewards').query();
            query.ascending("amount");
            return query.find();
          },
          sections: function (project, ProjectSectionSchema) {
            let query = project.get('sections').query();
            return query.find();
          }
        }
      });
  })
  .component('projectEditor', new ProjectEditorComponent());

export default ProjectEditorPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/project-editor/project-editor.module.js